// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2253":"00d4771ee9374b87","7028":"6f04a0b46af72fcf"}[chunkId] + ".css";
};